import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "modal fade show d-block",
    tabindex: "-1",
    role: "dialog",
    "raria-hidden": "true"
};
const _hoisted_2 = {
    class: "modal-dialog modal-dialog-centered modal-auto",
    role: "document"
};
const _hoisted_3 = { class: "modal-content" };
const _hoisted_4 = { class: "modal-header justify-content-between" };
const _hoisted_5 = {
    key: 0,
    class: "modal-title",
    id: "confirmeModalLongTitle"
};
const _hoisted_6 = {
    key: 1,
    class: "modal-title",
    id: "confirmeModalLongTitle"
};
const _hoisted_7 = { class: "modal-footer" };
const _hoisted_8 = { class: "modal-body" };
const _hoisted_9 = {
    key: 0,
    class: "d-flex flex-row gap-16px"
};
const _hoisted_10 = { class: "create-route-panel-body flex-1" };
const _hoisted_11 = { class: "d-flex flex-row gap-16px w-100" };
const _hoisted_12 = { class: "flex-1" };
const _hoisted_13 = { class: "flex-1" };
const _hoisted_14 = { class: "d-flex flex-row gap-16px w-100" };
const _hoisted_15 = { class: "flex-1" };
const _hoisted_16 = { class: "flex-1" };
const _hoisted_17 = { class: "container mt-4" };
const _hoisted_18 = { class: "row align-items-center" };
const _hoisted_19 = { class: "col-6 text-end" };
const _hoisted_20 = { class: "container mt-4" };
const _hoisted_21 = { class: "row align-items-center" };
const _hoisted_22 = { class: "col-6 text-end" };
const _hoisted_23 = { class: "w-100" };
import Multiselect from 'vue-multiselect';
import InputComponent from '../components/Input.vue';
import TextAreaComponent from '../components/TextArea.vue';
import ImgUploadComponentOffer from '../components/ImageUpload/ImgUploadComponent.vue';
import LanguageComponent from '../components/Language.vue';
import ValidateModal from '../components/ValidateModal.vue';
import axios from 'axios';
import { closeModal, closeById, pushModal } from "jenesius-vue-modal";
import { ref, onMounted, onBeforeMount } from 'vue';
import { useToast } from 'vue-toast-notification';
import { buildTextFieldsFromDocument, initializeDocument, validateData } from '../lib/utils';
import 'vue-toast-notification/dist/theme-sugar.css';
import 'vue-loading-overlay/dist/css/index.css';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OfferModal',
    props: {
        baseUrl: { type: String },
        languageJson: { type: Array },
        campaignId: { type: String },
        edit: { type: Boolean, default: false },
        offerId: { type: String, default: null }
    },
    emits: ['return', 'hideImgUpload'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const isLoading = ref(false);
        const langCode = ref('it');
        const imagesData = ref([]);
        const validateText = ref([]);
        const labelData = ref([]);
        const $toast = useToast();
        const token = ref('');
        const selectedOfferType = ref(null);
        const offerTypes = [{ name: 'Voucher FVV', value: 1 }];
        const is_rtl = ref(false);
        const document = ref({});
        const languageData = ref(props.languageJson.filter(val => !val.is_sign_language && !val.tours_only));
        // campi multilingua
        const MULTILANGFIELDS = ['title', 'description'];
        async function initDocument() {
            document.value = {
                ...initializeDocument(MULTILANGFIELDS, languageData),
                voucherValue: 10,
                voucherLimit: 100,
            };
            selectedOfferType.value = offerTypes[0];
            if (props.edit && props.offerId) {
                await fetchDataById();
            }
            console.log('document', document.value);
            imagesData.value = document.value.images?.length ? document.value.images : [];
        }
        //Recupero l'offerta dall'id
        const fetchDataById = async () => {
            isLoading.value = true;
            try {
                const response = await axios.get(`${props.baseUrl}/v1/private/offers/${props.offerId}`, {
                    headers: { Authorization: `Bearer ${token.value}`, 'Accept-Language': '' },
                });
                document.value = { ...response.data };
                // aggiorno textfields con valori dal backend
                if (document.value.textFields?.length) {
                    document.value.textFields.forEach(field => {
                        const key = field.key;
                        // inizializzo il campo se non esiste
                        if (!document.value[key]) {
                            document.value[key] = {};
                        }
                        document.value[key][field.languageCode] = field.value;
                    });
                }
            }
            catch (error) {
                console.error('Error fetching offer by ID:', error);
            }
            finally {
                isLoading.value = false;
            }
        };
        // Funzione per creare l'offerta (NEW)
        const handleSaveDraft = async () => {
            validateText.value = validateData(props.languageJson, MULTILANGFIELDS, document);
            if (validateText.value.length) {
                onShowModal();
                return;
            }
            const textFields = buildTextFieldsFromDocument(document, MULTILANGFIELDS);
            try {
                const doc = {
                    status: 'DRAFT',
                    name: document.value.title['it'],
                    textFields: textFields,
                    images: imagesData.value.map(i => i.uuid),
                    type: selectedOfferType.value?.value,
                    points: 0,
                    voucherLimit: document.value.voucherLimit,
                    voucherValue: document.value.voucherValue,
                    campaignId: props.campaignId
                };
                await axios.post(`${props.baseUrl}/v1/private/offers`, doc, { headers: { Authorization: `Bearer ${token.value}` }, })
                    .then(res => {
                    if (res.status === 200) {
                        $toast.success("Offerta creata con successo", { position: 'top-right' });
                        hideModal();
                        emit('return');
                    }
                });
            }
            catch (err) {
                console.error(err);
                $toast.error(err.response.data.title, { position: 'top-right' });
            }
        };
        // Funzione per salvare l'offerta (EDIT)
        const handleSave = async () => {
            validateText.value = validateData(props.languageJson, MULTILANGFIELDS, document);
            if (validateText.value.length) {
                onShowModal();
                return;
            }
            const textFields = buildTextFieldsFromDocument(document, MULTILANGFIELDS);
            try {
                const doc = {
                    status: document.value?.status?.name,
                    name: document.value.title['it'],
                    textFields: textFields,
                    images: imagesData.value.map(i => i.uuid),
                    type: selectedOfferType.value?.value,
                    points: 0,
                    voucherLimit: document.value.voucherLimit,
                    voucherValue: document.value.voucherValue,
                    campaignId: props.campaignId
                };
                await axios.put(`${props.baseUrl}/v1/private/offers/${props.offerId}`, doc, { headers: { Authorization: `Bearer ${token.value}` }, })
                    .then(res => {
                    if (res.status === 200) {
                        $toast.success("Offerta salvata con successo", { position: 'top-right' });
                        hideModal();
                        emit('return');
                    }
                });
            }
            catch (err) {
                console.error(err);
                $toast.error(err.response.data.title, { position: 'top-right' });
            }
        };
        // Funzione per pubblicare l'offerta (EDIT)
        const handlePublish = async () => {
            validateText.value = validateData(props.languageJson, MULTILANGFIELDS, document);
            if (validateText.value.length) {
                onShowModal();
                return;
            }
            const textFields = buildTextFieldsFromDocument(document, MULTILANGFIELDS);
            try {
                const doc = {
                    status: 'PUBLISHED',
                    name: document.value.title['it'],
                    textFields: textFields,
                    images: imagesData.value.map(i => i.uuid),
                    type: selectedOfferType.value?.value,
                    points: 0,
                    voucherLimit: document.value.voucherLimit,
                    voucherValue: document.value.voucherValue,
                    campaignId: props.campaignId
                };
                await axios.put(`${props.baseUrl}/v1/private/offers/${props.offerId}`, doc, { headers: { Authorization: `Bearer ${token.value}` }, })
                    .then(res => {
                    if (res.status === 200) {
                        $toast.success("Offerta pubblicata con successo", { position: 'top-right' });
                        hideModal();
                        emit('return');
                    }
                });
            }
            catch (err) {
                console.error(err);
                $toast.error(err.response.data.title, { position: 'top-right' });
            }
        };
        const handleLang = (payload) => {
            labelData.value = payload;
            const lang = props.languageJson.find(l => l.name === payload)?.lang_code;
            const rtl = props.languageJson.find(l => l.name === payload)?.is_rtl;
            if (lang)
                langCode.value = lang;
            if (rtl !== undefined)
                is_rtl.value = rtl;
        };
        const handleUpload = (payload) => {
            imagesData.value = payload;
        };
        const onShowModal = async () => {
            const modal = await pushModal(ValidateModal, {
                modalTitle: 'Avvertimento',
                modalContent: validateText.value
            });
            modal.on('confirm', () => {
                closeById(modal.id);
            });
        };
        const hideModal = () => {
            emit('hideImgUpload');
            closeModal();
        };
        onBeforeMount(() => {
            isLoading.value = true;
            const data = localStorage.getItem('mi_cms-tokens');
            if (data)
                token.value = JSON.parse(data).access;
            initDocument();
        });
        onMounted(() => {
            if (props.languageJson.length) {
                languageData.value = props.languageJson.filter(val => val.is_sign_language === false && val.tours_only === false);
            }
            isLoading.value = false;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            (__props.edit)
                                ? (_openBlock(), _createElementBlock("h5", _hoisted_5, "Modifica Offerta"))
                                : (_openBlock(), _createElementBlock("h5", _hoisted_6, "Nuova Offerta")),
                            _createElementVNode("div", _hoisted_7, [
                                (__props.edit)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "btn btn-primary",
                                        onClick: handleSave
                                    }, "Salva"))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "btn btn-primary",
                                        onClick: handleSaveDraft
                                    }, "Salva bozza")),
                                (document.value.status?.id === 2)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 2,
                                        type: "button",
                                        class: "btn btn-primary",
                                        onClick: handlePublish
                                    }, "Pubblica"))
                                    : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-secondary",
                                    onClick: hideModal
                                }, "Annulla")
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            (!isLoading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("div", _hoisted_12, [
                                                _createVNode(InputComponent, {
                                                    modelValue: document.value.title[langCode.value],
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((document.value.title[langCode.value]) = $event)),
                                                    title: "Titolo",
                                                    "max-number": 50,
                                                    placeholder: "Inserisci un titolo",
                                                    "is-rtl": is_rtl.value
                                                }, null, 8, ["modelValue", "is-rtl"])
                                            ]),
                                            _createElementVNode("div", _hoisted_13, [
                                                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title-input" }, "Tipo di offerta", -1)),
                                                _createVNode(_unref(Multiselect), {
                                                    class: "mt-1",
                                                    searchable: false,
                                                    "show-labels": false,
                                                    "allow-empty": false,
                                                    "track-by": "name",
                                                    label: "name",
                                                    placeholder: "Seleziona il tipo",
                                                    modelValue: selectedOfferType.value,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedOfferType).value = $event)),
                                                    options: offerTypes
                                                }, null, 8, ["modelValue"])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("div", _hoisted_15, [
                                                _createVNode(TextAreaComponent, {
                                                    modelValue: document.value.description[langCode.value],
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((document.value.description[langCode.value]) = $event)),
                                                    title: "Descrizione",
                                                    "max-number": 2000,
                                                    rows: 8,
                                                    placeholder: "Inserisci una descrizione",
                                                    "is-rtl": is_rtl.value
                                                }, null, 8, ["modelValue", "is-rtl"])
                                            ]),
                                            _createElementVNode("div", _hoisted_16, [
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("div", _hoisted_18, [
                                                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-5 text-start" }, [
                                                            _createElementVNode("div", { class: "title-input" }, "Valore iniziale Voucher")
                                                        ], -1)),
                                                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-1 text-start" }, [
                                                            _createElementVNode("div", { class: "title-input" }, "€")
                                                        ], -1)),
                                                        _createElementVNode("div", _hoisted_19, [
                                                            (!isLoading.value)
                                                                ? (_openBlock(), _createBlock(InputComponent, {
                                                                    key: 0,
                                                                    modelValue: document.value.voucherValue,
                                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((document.value.voucherValue) = $event)),
                                                                    type: "number",
                                                                    "max-number": 10,
                                                                    placeholder: "",
                                                                    "is-rtl": is_rtl.value
                                                                }, null, 8, ["modelValue", "is-rtl"]))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_20, [
                                                    _createElementVNode("div", _hoisted_21, [
                                                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-6 text-start" }, [
                                                            _createElementVNode("div", { class: "title-input" }, "Numero di Voucher in palio")
                                                        ], -1)),
                                                        _createElementVNode("div", _hoisted_22, [
                                                            (!isLoading.value)
                                                                ? (_openBlock(), _createBlock(InputComponent, {
                                                                    key: 0,
                                                                    modelValue: document.value.voucherLimit,
                                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((document.value.voucherLimit) = $event)),
                                                                    type: "number",
                                                                    "max-number": 10,
                                                                    placeholder: "",
                                                                    "is-rtl": is_rtl.value
                                                                }, null, 8, ["modelValue", "is-rtl"]))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_23, [
                                            _createVNode(ImgUploadComponentOffer, {
                                                token: token.value,
                                                baseUrl: props.baseUrl,
                                                initImages: imagesData.value,
                                                onHandleUpload: handleUpload
                                            }, null, 8, ["token", "baseUrl", "initImages"])
                                        ])
                                    ]),
                                    _createElementVNode("div", null, [
                                        _createVNode(LanguageComponent, {
                                            onHandleLang: handleLang,
                                            token: token.value,
                                            languageJson: languageData.value,
                                            baseUrl: props.baseUrl,
                                            style: { "min-width": "160px" }
                                        }, null, 8, ["token", "languageJson", "baseUrl"])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ]));
        };
    }
});
